<template>
  <div class='user'>
    <img :src="data.avatar | imageUrl('/static/peopleCenter/headPicture.png',40,40)">
    <div class="description">
      <p class="name">{{ data.nickname }}</p>
      <p class="profession">{{ data.field }}</p>
      <button class="peopleHome" @click='Follow(data)'>{{!data.isFollow?$t('global.关注'):$t('global.取消关注')}}</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        userId: 0,
        nickname: "",
        avatar: "",
        field: "",
        isCertification: 2, //$t('global.是否认证') 1$t('global.是') 2$t('global.否')
      }
    },
    methods: {
      Follow(item) {
        let that = this;
        if (!localStorage.getItem("auth_token")) {
          this.$router.push(
            "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
          );
          return;
        }
        this.$http
          .post(`/api/u/relation/${!item.isFollow ? 'follow' : 'unfollow'}/${item.userId}`)
          .then(function (response) {
            if (response) {
              item.isFollow = !item.isFollow;
              that.$message(response.message);
            }
          });
      },
    }
  };
</script>

<style lang="stylus" scoped>
  .user {
    display: flex;
    // width: 6.5rem;

    img {
      width: 1.3rem;
      height: 1.3rem;
      border-radius: .9rem;
    }

    .description {
      width: 1.8rem;
      margin-left: 0.3rem;
    }

    .peopleHome {
      width: 1.2rem;
      height: 0.41rem;
      line-height: 0.41rem;
      margin-top: 0.12rem;
      color: #ffffff;
      text-align: center;
      text-indent: 0;
      font-size: 0.16rem;
      background-color: #0060ff;
      border-radius: 0.2rem;
    }

    .profession {
      font-size: 0.16rem;
      color: #777777;
      margin-top: 0.12rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .name {
      color: #333333;
      font-size: 0.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/User.vue